import { render, staticRenderFns } from "./Foundation.vue?vue&type=template&id=112c9470&scoped=true&"
import script from "./Foundation.vue?vue&type=script&lang=js&"
export * from "./Foundation.vue?vue&type=script&lang=js&"
import style0 from "./Foundation.vue?vue&type=style&index=0&id=112c9470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c9470",
  null
  
)

component.options.__file = "Foundation.vue"
export default component.exports